import {useEffect, useState} from 'react';
import {useQueryClient} from 'react-query';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';
import CreateNewRequest from '../../../../createNewRequest/createNewRequest';
import LoanTemplateDetail from './LoanTemplateDetail';
import LoanTemplateList from './LoanTemplateList';
import LayoutWithoutDrawer from '../../../../../layouts/LayoutWithoutDrawer';
import BasicInforContainer from '../../../../basicInformation/basicInfoContainer';

const LoanTemplateContainer = ({
    setStep,
    setTabChild,
}: {
    setStep: any;
    setTabChild: any;
}) => {
    const [innerState, setInnerState] = useState<
        | 'selectLoanTemplate'
        | 'confirmLoanTemplate'
        | 'createNewRequest'
        | 'TemporaryRegistered'
    >('selectLoanTemplate');
    const [key, setKey] = useState<string>('');
    const stateFromRedux = useSelector(
        (state: RootState) => state.prevAndNextState.nextState
    );
    const stateFromBack = useSelector(
        (state: RootState) => state.prevAndNextState.nextInnerState
    );
    const queryClient = useQueryClient();
    const currentState = {
        selectLoanTemplate: (
            <LoanTemplateList setInnerState={setInnerState} setKey={setKey} />
        ),
        confirmLoanTemplate: (
            <LoanTemplateDetail
                setInnerState={setInnerState}
                setTabChild={setTabChild}
                loanTemplateKey={
                    key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')!
                }
            />
        ),
        createNewRequest: (
            <CreateNewRequest
                setInnerState={setInnerState}
                setStep={setStep}
                loanTemplateKey={
                    key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')
                }
            />
        ),
        TemporaryRegistered: (
            <LayoutWithoutDrawer>
                <BasicInforContainer
                    referenceKey={undefined!}
                    setStep={setStep}
                    back="calculator"
                />
            </LayoutWithoutDrawer>
        ),
    };
    useEffect(() => {
        if (stateFromBack.includes('confirmLoanTemplate'))
            setInnerState('confirmLoanTemplate');
        else if (stateFromBack.includes('selectLoanTemplate'))
            setInnerState('selectLoanTemplate');
        else if (stateFromBack.includes('createNewRequest'))
            setInnerState('createNewRequest');
        else if (stateFromBack.includes('TemporaryRegistered'))
            setInnerState('TemporaryRegistered');
    }, [stateFromBack]);

    useEffect(() => {
        if (stateFromRedux.includes('confirmLoanTemplate'))
            setInnerState('confirmLoanTemplate');
        else if (stateFromRedux.includes('selectLoanTemplate'))
            setInnerState('selectLoanTemplate');
        else if (stateFromRedux.includes('createNewRequest'))
            setInnerState('createNewRequest');
        else if (stateFromRedux.includes('TemporaryRegistered'))
            setInnerState('TemporaryRegistered');
    }, [stateFromRedux]);
    return <div>{currentState[innerState!]}</div>;
};

export default LoanTemplateContainer;
